import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import AnimatedSection from '../Common/AnimatedSection';
import IntroSection from '../Common/IntroSection';
import ServiceInformationSection from './ServiceInformationSection';
import TestimonialsSection from '../Common/TestimonialSection';
import PricingInsuranceSection from '../Common/PricingInsuranceSection';
import VisitUsSection from '../Common/VisitUsSection';
import BookVisitSection from '../Common/BookVisitSection';
import DentalFAQ from './DentalFAQ';
import CheckInComponent from './CheckInComponent';
import PromoSection from '../Common/PromoSection';
import ServiceAccordianSection from './ServiceAccordianSection';
import { ServiceCategoryInfo } from '../../const/ServiceInfo';

const Services = () => {
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  const location = useLocation()
  const page = location.pathname.substring(1)

  return (
    <div className="service">
      <AnimatedSection id='intro' delay={200}>
        <IntroSection 
          title={ServiceCategoryInfo[page].title} 
          about={ServiceCategoryInfo[page].tagline} />
      </AnimatedSection>

      <AnimatedSection id='serviceInformation' delay={400}>
        <ServiceInformationSection serviceInfo={ServiceCategoryInfo[page].serviceInfo} />
      </AnimatedSection>

      <AnimatedSection id='checkInComponent' delay={600}>
        <CheckInComponent />
      </AnimatedSection>

      <AnimatedSection id='serviceAccordianSection' delay={800}>
        <ServiceAccordianSection services={ServiceCategoryInfo[page].services} serviceName={page} />
      </AnimatedSection>

      <AnimatedSection id='promoSection' delay={1000}>
        <PromoSection />
      </AnimatedSection>

      <AnimatedSection id='testimonials' delay={1200}>
        <TestimonialsSection />
      </AnimatedSection>

      <AnimatedSection id='pricing' delay={1400}>
        <PricingInsuranceSection />
      </AnimatedSection>
      
      <AnimatedSection id='visitUs' delay={1600}>      
        <VisitUsSection />
      </AnimatedSection>

      <AnimatedSection id='faqComponent' delay={800}>
        <DentalFAQ faqs={ServiceCategoryInfo[page].faqs} />
      </AnimatedSection>

      <AnimatedSection id='bookVisit' delay={1800}>
        <BookVisitSection />
      </AnimatedSection>
    </div>
  );
}

export default Services;